import React, { useEffect } from 'react';
import Header from './header';
import Footer from './footer';
import { Link, useNavigate } from "react-router-dom";

function Thankyou() {
    const navigate = useNavigate();

    useEffect(() => {
        // Iniciamos el temporizador de 1000 ms (1 segundo)
        const timer = setTimeout(() => {
            navigate("/agenda"); // Redirige a /#/agenda
        }, 2000);

        // Limpieza del timer si el usuario se va de la página antes del segundo
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <>
            <Header active="Agenda"></Header>
            <div style={{ textAlign: 'center', padding: '50px' }}>
                <h1>Consulta Agendada Correctamente</h1>
                <p>Redirigiendo a tu agenda...</p>
                <Link to="/">
                    <button className='volverIndex'>Volver al Inicio</button>
                </Link>
            </div>
            <Footer />
        </>
    );
}

export default Thankyou;